<template>
    <div class="page bg-grey">
        <step-section></step-section>
        <div class="offer-title">
            <div class="bg-title">
                <div class="title_sect bg-img" style="background-image: url('../../../img/stockholm-market.png');">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="relawaySM p-title">Compare electricity in Stockholm</h1>
                                <p class="min-med p-white Raleway">We found <b>188</b>  electricity contracts for postcode: <b>45134</b></p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="title_sect bg-color pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="relawayBold p-title d-flex align-items-center">Result for postcode  45134 <span class="marker"><img src="../../../img/marker-black.svg" alt="">Stockholm</span></h1>
                        <p class="min-med Raleway">188 results</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="filter-mobile-togler">
            <div class="container">

                <div class="toggler d-flex">
                    <span class="marker"><img src="../../../img/marker-black.svg" alt="">Stockholm</span>
                    <button class="toggler-btn ml-auto"  @click="showfilters()">
                        <img src="../../../img/icon/Filter_icn_black.svg" class="filter-img">Filters (6)
<!--                        <img src="/img/icon/arrow-black-v2.svg" alt="">-->
                    </button>
                </div>
            </div>
        </div>
        <div class="offer-filter new-filter" :class="{'mobile': isMobile, 'mobile-open': mobileOpen}" >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="toggler-row mobile">
                            <p class="min p-bold p-center">Pick filter</p>
                            <button class="close-btn " :class="{'active': showfilter}" @click="showfilters">Close filter</button>
                        </div>
                        <div class="toggler-row desktop">
                            <button class="toggler-btn" :class="{'active': showfilter}"  @click="showfilter = !showfilter">
                                <img src="../../../img/icon/Filter_icn_black.svg" class="filter-img">Filters (6)  <img src="/img/icon/arrow-black-v2.svg" alt="" class="filter-arrow"></button>
                        </div>
                        <transition name="fade">
                            <div  class="main-filter open" v-if="showfilter">
                                <div class="row justify-content-between">
                                    <div class="col-md-6 col-lg-5">
                                        <div class="filter-blck filter-dropdown big-dropdown" v-click-outside="closetoogleshow4">
                                            <div class="label min p-bold p-dgrey">Contract type <span class="quest__in_icon" :class="{'active': active1}" @click="active1 = !active1"></span>
                                                <div class="mini-popup" v-if="active1"  :class="{'active': active1}"  @click="active1 = !active1">
                                                    <div class="m_popup__blck">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                        </div>
                                                        <div class="content">
                                                            <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="main-dropdown">
                                            <button class="btn btn-white btn-full small dropdown"
                                                    :class="{'active': show4}"
                                                    @click="show4 = !show4">All types</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show4">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                            <img src="../../../img/icon/all-contract.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>All types</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="../../../img/icon/fixed-contract.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Fixed price</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="../../../img/icon/variable-contract.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Variable price</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="../../../img/icon/mix-contract.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Mix price</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="checkbox-btn">
                                            <div class="label min p-bold p-dgrey">Binding time <span class="quest__in_icon" :class="{'active': active1}" @click="active1 = !active1"></span>
                                                <div class="mini-popup" v-if="active1"  :class="{'active': active1}"  @click="active1 = !active1">
                                                    <div class="m_popup__blck">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                        </div>
                                                        <div class="content">
                                                            <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="checks-list">
                                                <div class="checkbox-item">
                                                    <input type="radio" value="1"  name="checkbox-item" />
                                                    <span>All</span>
                                                </div>
                                                <div class="checkbox-item">
                                                    <input type="radio" value="1"  name="checkbox-item" />
                                                    <span>Without binding</span>
                                                </div>
                                                <div class="checkbox-item">
                                                    <input type="radio" value="1"  name="checkbox-item" />
                                                    <span>With binding</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow">
                                            <label class="min  p-bold p-dgrey">Payment method </label>
                                            <button class="btn btn-white btn-full small dropdown"
                                                    :class="{'active': show}"
                                                    @click="show = !show">E-faktura</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/autogiro.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Autogiro</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/check.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>E-faktura</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/file.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Traditionell</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>

                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow2">
                                            <label class="min  p-bold p-dgrey">Choose production sources</label>
                                            <button class="btn btn-white btn-full small dropdown"
                                                    :class="{'active': show2}"
                                                    @click="show2 = !show2">Some long text without dashes</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show2">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/sun.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Sun</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/wind.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Wind</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/drop.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Water</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/leaf.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Nature</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/ecology.svg" alt="">
                                                            <span class="checkbox">
                                                                                    <input type="checkbox" title="title">
                                                                                    <span class="box"></span>
                                                                                </span>
                                                            <label>Good environmental choice</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow3">
                                            <label class="min  p-bold p-dgrey">Sort by</label>
                                            <button class="btn btn-white btn-full small dropdown"
                                                    :class="{'active': show3}"
                                                    @click="show3 = !show3">All types</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show3">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">

                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">

                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">

                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">

                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3 d-flex align-items-end justify-content-start">
                                        <div class="filter-blck eco">
                                            <!--checkbox error add class "check-error"-->
                                            <span class="checkbox">
                                                               <input type="checkbox" title="title">
                                                               <span class="box"></span>
                                                           </span>
                                            <label class="min p-dgrey">Good environmental choice</label>
                                            <img src="/img/icon/ecology.svg" alt="">
                                            <!--end error-->
                                        </div>
                                    </div>
                                </div>
                                <div class="action-btn">
                                    <button class="btn">Reset filters(2)</button>
                                    <button class="result">188 results</button>

                                </div>

                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

        <div class="filter-result">
            <div class="container">
                <div class="row">
                    <new-offer-result-item
                            v-for="(resultItem, key) in res"
                            :itemData="resultItem"
                            :keyItem="key"
                            :key="key"
                            :localItem="resultItem.localItem"
                            @modalActive="openModal()"

                    ></new-offer-result-item>

                </div>
            </div>
            <div class="container">
                <div class="pagination">
                    <div class="prev">
                        <a href="#" class="btn-prev btn-page"><img src="../../../img/icon/arrow-white-v2.svg" alt=""></a>
                    </div>
                    <div class="page-list">
                        <span>
                          <a href="#">1</a>
                        </span>
                        <span>
                          <a href="#" class="current">2</a>
                        </span>
                        <span>
                            <a href="#" >3</a>
                        </span>
                        <span>
                            <span class="dotted">...</span>
                        </span>
                        <span>
                            <a href="#" class="last">25</a>
                        </span>
                    </div>
                    <div class="next">
                        <a href="#" class="btn-next btn-page"><img src="../../../img/icon/arrow-white-v2.svg" alt=""></a>
                    </div>
                </div>

            </div>

<!--            <div class="show-more p-center">-->
<!--                <button class="btn btn-blue small"-->
<!--                        :class="{'load':preloaded}"-->
<!--                        :disabled="preloaded"-->
<!--                        @click="preloadBlock">-->
<!--                    Show more (Total: 95)-->
<!--                    <span v-if="preloaded">-->
<!--                                            <img src="/img/tail-spin.svg" alt="">-->
<!--                                        </span>-->
<!--                </button>-->
<!--            </div>-->

            <div class="info-popup open" v-if="modal">
                <div class="popupoverlay"   @click="openModal()"></div>
                <div class="mainpopup">
                    <div class="close" @click="openModal()"></div>
                    <div class="popup_body">

                        <div class="title">
                            <p class="p-black p-bold  med"><b>Info</b></p>
                        </div>
                        <div class="content">
                            <p class="min-min">It is currently not possible to get our help with the change to this company, as they lack a cooperation with el skling.se.
                            </p>
                            <p>If you want our free help with changing here and now, we suggest the next possible agreement in your list. For you it is Skellefteå Kraft AB's 36 month agreement. The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an environmental agreement. </p>
                            <p> Would this agreement fit in instead?</p>
                        </div>
                        <div class="submit__btn">
                            <div class="row">

                                <div class="col-md-12">
                                    <button class="btn btn-green btn-full small">AND</button>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn btn-white btn-full small">NO</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fixed-ad-el></fixed-ad-el>
    </div>
</template>

<script>
    import fixedAdEl from "./page-part/fixedAdEl";
    import StepSection from "./page-part/StepSection";
    import newOfferResultItem from '../Partials/newOfferResultItem'

    const offerLIst = [
        { typeenergy: true, localItem: true},
        { typeenergy: true, localItem: false, numbers: 1},
        { typeenergy: true, localItem: false, numbers: 2},
        { typeenergy: true, localItem: false, numbers: 3},
        { typeenergy: true, localItem: false, numbers: 4},
        { typeenergy: true, localItem: false, numbers: 5},
    ];

    export default {
        name: "OfferListNew",
        components: {
            fixedAdEl,
            StepSection,
            newOfferResultItem
        },
        data: function(){
            return {
                showfilter: false,
                show: false,
                show2: false,
                show3: false,
                show4: false,
                res: offerLIst,
                active1: false,
                modal: false,
                preloaded: false,
                res2: offerLIst,

                mobile: false,
                windowWidth: 0,
                mobileOpen: false


            }
        },
        component:{
            fixedAdEl,
        },
        methods: {
            openModal(){
                let paddingRight = window.innerWidth - document.body.offsetWidth;

                const scrollY = document.body.style.top;

                if(this.modal){

                    document.body.classList.remove('no-scroll');
                    document.body.style.paddingRight = '';
                    window.scrollTo(0, parseInt(scrollY || '0') * -1);
                    this.modal = false;
                } else {
                    document.body.classList.add('no-scroll');
                    document.body.style.top = `-${scroll}px`;
                    document.body.style.paddingRight = paddingRight + 'px';
                    this.modal = true;
                }

            },
            showfilters(){

                if(this.isMobile){
                    let paddingRight = window.innerWidth - document.body.offsetWidth;
                    let scroll = window.scrollY;
                    const scrollY = document.body.style.top;
                    if (this.mobileOpen) {
                        document.body.classList.remove('no-scroll');
                        document.body.style.paddingRight = '';
                        window.scrollTo(0, parseInt(scrollY || '0') * -1);
                        this.showfilterText = "Show filters";
                        this.mobileOpen = false;

                    } else {
                        document.body.classList.add('no-scroll');
                        document.body.style.top = `-${scroll}px`;
                        document.body.style.paddingRight = paddingRight + 'px';
                        this.showfilterText = "Hide filters";
                        this.mobileOpen = true;
                    }
                } else {
                    if (this.showfilter) {
                        this.showfilterText = "Show filters";
                        this.showfilter = false;
                    } else {
                        this.showfilterText = "Hide filters";
                        this.showfilter = true;
                    }
                }

            },
            openMobileFilter(){

            },


            preloadBlock(){
                let preloader =  this.preloaded = true;
                let data = this;
                let delay = 1000;
                this.res2.map(function(value, key) {
                    setTimeout(function(){
                        console.log(key);
                        data.res.push(value);
                        if(data.res.length === 6 ){
                            data.preloaded = false;

                        }
                    }, delay * (key + 1));
                });
                this.preloaded = preloader;
            },
            closetoogleshow(){
                this.show = false
            },
            closetoogleshow2(){
                this.show2 = false
            },
            closetoogleshow3(){
                this.show3 = false
            },
            closetoogleshow4(){
                this.show4 = false
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },

        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            isMobile: function () {
                if(this.windowWidth > 425){
                    this.showfilter = false;
                    return false;
                } else {
                    this.showfilter = true;
                    return true;
                }

            }
        }
    }
</script>

